var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0135 6.58572L18.0252 3.23633H4.07286C3.61072 3.23633 3.19211 3.42386 2.88904 3.72693C2.58597 4.03 2.39844 4.44917 2.39844 4.9113C2.39844 5.83614 3.14802 6.58572 4.07286 6.58572H20.5023V11.4622",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5023 15.3655V20.7203H4.08067C3.15137 20.7203 2.39844 19.9668 2.39844 19.0381V4.91211",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5472 13.4142C17.5472 13.863 17.1833 14.2269 16.7345 14.2269C16.2858 14.2269 15.9219 13.863 15.9219 13.4142C15.9219 12.9655 16.2858 12.6016 16.7345 12.6016C17.1833 12.6016 17.5472 12.9655 17.5472 13.4142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7598 15.3654H21.5645V11.4629H15.7598C14.6821 11.4629 13.8086 12.3364 13.8086 13.4141C13.8086 14.4919 14.6821 15.3654 15.7598 15.3654Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.4f3f9352b8e9ac39255954888a027565.svg";
export { ForwardRef as ReactComponent };